import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { LogoCarouselComponent, type LogoImage } from '../../ui/logo-carousel/logo-carousel.component';

@Component({
    selector: 'app-customers',
    templateUrl: './customers.component.html',
  imports: [
    TranslateModule,
    LogoCarouselComponent
],
    styleUrls: ['./customers.component.scss']
})
export class CustomersComponent {
  @Input() hasTitle = true;

  images: LogoImage[] = [
    {
      id: 1,
      src: '/assets/img/website/logos_black/dla_piper.svg',
      width: 79,
      height: 47,
      alt: 'DLA Piper logo'
    },
    {
      id: 2,
      src: '/assets/img/website/logos_black/eide.svg',
      width: 100,
      height: 36,
      alt: 'Eide logo'
    },
    {
      id: 3,
      src: '/assets/img/website/logos_black/kaffe.svg',
      width: 154,
      height: 30,
      alt: 'Kaffebrenneriet logo'
    },
    {
      id: 4,
      src: '/assets/img/website/logos_black/krogsveen.svg',
      width: 129,
      height: 27,
      alt: 'Krogsveen logo'
    },
    {
      id: 5,
      src: '/assets/img/website/logos_black/torvald_klaveness.svg',
      width: 150,
      height: 34,
      alt: 'Torwald klaveness logo'
    },
    {
      id: 6,
      src: '/assets/img/website/logos_black/arntzen.svg',
      width: 90,
      height: 36,
      alt: 'Arntzen de Besche logo'
    },
    {
      id: 7,
      src: '/assets/img/website/logos_black/fredrik_louisa.svg',
      width: 243,
      height: 27,
      alt: 'Frederik & Louisa logo'
    },
    {
      id: 8,
      src: '/assets/img/website/logos_black/w_b_samson.svg',
      width: 142,
      height: 44,
      alt: 'W.B. Samson logo'
    },
    {
      id: 9,
      src: '/assets/img/website/logos_black/arctic.svg',
      width: 169,
      height: 33,
      alt: 'Arctic logo'
    },
    {
      id: 10,
      src: '/assets/img/website/logos_black/bjerke.svg',
      width: 108,
      height: 42,
      alt: 'Bjerke logo'
    },
    {
      id: 11,
      src: '/assets/img/website/logos_black/devold.svg',
      width: 124,
      height: 30,
      alt: 'Devold logo'
    },
    {
      id: 12,
      src: '/assets/img/website/logos_black/eindoms_megler.svg',
      width: 220,
      height: 39,
      alt: 'Eindoms Megler logo'
    },
    {
      id: 13,
      src: '/assets/img/website/logos_black/eplehuset.svg',
      width: 82,
      height: 59,
      alt: 'Eplehuset logo'
    },
    {
      id: 14,
      src: '/assets/img/website/logos_black/jernia.svg',
      width: 117,
      height: 29,
      alt: 'Jernia logo'
    },
    {
      id: 15,
      src: '/assets/img/website/logos_black/selmer.svg',
      width: 106,
      height: 27,
      alt: 'Selmer logo'
    },
    {
      id: 16,
      src: '/assets/img/website/logos_black/ey.svg',
      width: 53,
      height: 58,
      alt: 'EY logo'
    },
    {
      id: 17,
      src: '/assets/img/website/offshore/logo/sea1.png',
      width: 100,
      height: 26,
      alt: 'Sea1 logo'
    },
    {
      id: 18,
      src: '/assets/img/website/retail/sprell.png',
      width: 126,
      height: 43,
      alt: 'Sprell logo'
    },
    {
      id: 19,
      src: 'assets/img/website/group-structure/fred_plsen.png',
      width: 255,
      height: 27,
      alt: 'Fred Olsen logo'
    },
    {
      id: 20,
      src: '/assets/img/website/logos_black/sem_and_johnsen.svg',
      width: 47,
      height: 46,
      alt: 'Sem and Johnsen logo'
    },
    {
      id: 21,
      src: '/assets/images/logos/dnt.png',
      width: 60,
      height: 60,
      alt: 'Den Norske logo'
    }
  ];
}
